module.exports = __webpack_public_path__ + "static/img/Ícono_materiales interactivos copia@4x.99daa84c.png";